"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.factsByAccountByType = void 0;
const key_by_1 = require("../../helpers/key-by");
exports.factsByAccountByType = (state = {}, action = {}) => {
    switch (action.type) {
        case 'FACTS_GET_BY_ACCOUNT_RECEIVE':
            const accountsFacts = action.payload.facts.filter((fact) => fact.account);
            return Object.assign(Object.assign({}, state), { [action.payload.accountId]: key_by_1.keyEntitiesBy(accountsFacts, 'type') });
        case 'FACT_UPSERT_ACCOUNT_RECEIVE':
            const existingFacts = state[action.payload.accountId] || {};
            return Object.assign(Object.assign({}, state), { [action.payload.accountId]: Object.assign(Object.assign({}, existingFacts), { [action.payload.fact.type]: action.payload.fact }) });
        default:
            return state;
    }
};
//# sourceMappingURL=reducer.js.map